import React from "react";
import './Clown.scss';
import LogoSloganImage from "../../../resources/images/ShipitLogoWithSlogan.png";
import axios from "axios";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Direction from "../../Utils/Direction/Direction";


export default class Clown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bid: '',
            clownName: ''
        };
    }

    handleClownNameChange(event) {
        this.setState({
            clownName: event.target.value
        });
    }

    handleBidChange(event) {
        this.setState({
            bid: event.target.value
        });
    }

    async handleSendButton() {
        if (this.clearSuccessTimeout)
            clearTimeout(this.clearSuccessTimeout);

        this.setState({
            isSendLoading: true,
            isSendSuccess: undefined
        });

        const {data: result} = await axios.get('/api/v2/scripts/clown', {
            params: {
                name: this.state.clownName,
                bid: this.state.bid
            }
        });

        this.setState({
            isSendLoading: false,
            isSendSuccess: result.success
        });

        this.clearSuccessTimeout = setTimeout((() => {
            this.setState({
                isSendSuccess: undefined
            });

            this.clearSuccessTimeout = undefined;
        }).bind(this), 2000);
    }

    render() {
        return (
            <Direction direction="rtl">
                <div className="page">
                    <div className="logo">
                        <img src={LogoSloganImage}/>
                    </div>

                    <div className="content">
                        <div className="page-title-text">
                            Clown
                        </div>
                        <div className="clown-content">
                            <FormControl>
                                <InputLabel id="demo-simple-select-label">שם הליצן</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={this.state.clownName}
                                    onChange={this.handleClownNameChange.bind(this)}
                                >
                                    <MenuItem value={"moses-kfar-saba"}>מוזס כפר סבא</MenuItem>
                                    <MenuItem value={"nagisa_netanya"}>סושי נגיסה נתניה</MenuItem>
                                    <MenuItem value={"burger_salon_holon"}>בורגר סאלון חולון</MenuItem>
                                    <MenuItem value={"beersheva"}>באר שבע</MenuItem>
                                    <MenuItem value={"fatvinny_hadera"}>פאט ויני חדרה</MenuItem>
                                    <MenuItem value={"video_1"}>סרטון 1</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField value={this.state.bid} onChange={this.handleBidChange.bind(this)}
                                       label="מזהה עסק"/>
                            <div className="send-button-container">
                                <Button
                                    disabled={this.state.isSendLoading}
                                    className={`send-button ${(this.state.isSendSuccess === true ? 'send-button-success' : this.state.isSendSuccess === false ? 'send-button-failure' : '')}`}
                                    variant="contained" color="primary"
                                    onClick={this.handleSendButton.bind(this)}>
                                    הרץ
                                </Button>
                                {this.state.isSendLoading &&
                                <CircularProgress size={24} className="send-button-loader"/>}
                            </div>
                        </div>
                    </div>
                </div>
            </Direction>
        );
    }
}